export default "__VITE_ASSET__d5dfedc4__"